import createAttachmentFromAttachmentDataProviderOperation from 'owa-service/lib/operation/createAttachmentFromAttachmentDataProviderOperation';
import { CloudFile } from 'owa-attachment-file-types';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import { ClientItemId } from 'owa-client-ids';

export default async function createAttachmentFromAttachmentDataProvider(
    parentItemId: ClientItemId,
    cancellationId: string,
    backingObject: CloudFile,
    subscriptionId: string,
    channelId: string,
    isInline: boolean
): Promise<string> {
    const requestOptions = getMailboxRequestOptions(parentItemId.mailboxInfo) || {};

    return await createAttachmentFromAttachmentDataProviderOperation(
        {
            itemId: parentItemId,
            attachmentDataProviderId: backingObject.providerId,
            location: backingObject.location,
            attachmentId: backingObject.fileId || '',
            subscriptionId: subscriptionId,
            channelId: channelId,
            dataProviderParentItemId: backingObject.fileParentId || '',
            providerEndpointUrl: backingObject.providerEndpointUrl,
            cancellationId: cancellationId,
            isInline: isInline,
        },
        requestOptions
    );
}
